export class Identifier {
	IdentifierType:string = "";
	Identifier:string = "";

	public constructor(data:any){
		this.IdentifierType = data.IdentifierType || "";
		this.Identifier = data.Identifier ||  "";
	}
}